var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            #svg_facebook_icon .a {\n                fill: #edeae5;\n            }\n\n            #svg_facebook_icon .b {\n                fill: #49161f;\n            }\n        ")),React.createElement("circle",{"className":"a","cx":"13.5","cy":"13.5","r":"13.5","key":1}),React.createElement("path",{"className":"b","d":"M9.268,8.607l.425-2.769H7.035v-1.8A1.385,1.385,0,0,1,8.6,2.545H9.8V.187A14.731,14.731,0,0,0,7.66,0,3.381,3.381,0,0,0,4.042,3.727v2.11H1.609V8.607H4.042V15.3H7.035V8.607Z","transform":"translate(7.099 6.145)","key":2})]);
}

FacebookIcon.defaultProps = {"id":"svg_facebook_icon","width":"27","height":"27","viewBox":"0 0 27 27"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
